import { tryEval } from "../../lib/utils/stringInterop";
class PluginNode {
  constructor(pluginId, pluginArgs, pluginConfig) {
    this.pluginArgs = pluginArgs;
    this.pluginId = pluginId;
    this.pluginConfig = pluginConfig;
  }
}
class PluginNodeRuntime {
  constructor(compPath) {
    this.pluginNodes = [];
    this.compPath = compPath;
  }
  use(pluginId, pluginArgs, pluginConfig) {
    this.pluginNodes.push(new PluginNode(pluginId, pluginArgs, pluginConfig));
  }
  apply(event, context) {
    return this.pluginNodes.map(pluginNode => this.execute(pluginNode, event, context));
  }
  execute(pluginNode, event, ctx) {
    const {
      pluginConfig,
      pluginId,
      pluginArgs
    } = pluginNode;
    if (!pluginConfig) {
      console.error(`无法加载生命周期插件${pluginId}`);
      return;
    }
    const hook = pluginConfig.plugin[event];
    if (!hook) {
      return;
    }
    let args = pluginArgs;
    if (pluginConfig.global) {
      var _ctx$renderer;
      const globalArgs = (_ctx$renderer = ctx.renderer) === null || _ctx$renderer === void 0 || (_ctx$renderer = _ctx$renderer.ucPagelet) === null || _ctx$renderer === void 0 || (_ctx$renderer = _ctx$renderer.globalPluginArgs) === null || _ctx$renderer === void 0 ? void 0 : _ctx$renderer[pluginId];
      args = pluginArgs || globalArgs;
    }
    const hookParams = this.generateHookParamsFromCtx(ctx, args);
    return hook(hookParams);
  }
  // 收集插件需要的参数
  generateHookParamsFromCtx(ctx, pluginArgs) {
    const node = ctx.componentInstances[this.compPath];
    const el = node === null || node === void 0 ? void 0 : node.$el;
    const data = tryEval(pluginArgs, ctx.renderer);
    return {
      el,
      node,
      data
    };
  }
}
export default PluginNodeRuntime;
//# sourceMappingURL=LifeCyclePluginRuntime.js.map
